module.exports = __webpack_public_path__ + "img/copy.35058879.svg";